import React from 'react';

const Footer = () => {
    return (
        <div className="copyright text-center py-3 bg-light"> {/* Added some basic styling for visibility */}
            <p className="mb-0">© 2025 Checkin. Todos los derechos reservados. Desarrollado por <a href="https://antudigital.cl" target="_blank" rel="noopener noreferrer">Antü Digital</a></p>
        </div>
    );
};

export default Footer;